export default __webpack_public_path__ + "static/media/education-icon.714eefc8.png";